import { Input, InputNumber, Select } from "antd";
import "./FillInBlankInputs.scss";

interface FillInBlankInputsProps {
  type: string;
  label?: string;
  required?: boolean;
  inputProp?: any;
}

export function FillInBlankInputs({
  type,
  label,
  required,
  inputProp,
}: FillInBlankInputsProps) {
  switch (type) {
    case "label":
      return (
        <label>
          {label}
          {required && (
            <>
              &nbsp;<span className="input-required">*</span>
            </>
          )}
        </label>
      );
    case "text":
      return <>{label}</>;
    case "input":
      return <Input className="fill-in-blank-input" {...inputProp} />;
    case "number":
      return <InputNumber className="fill-in-blank-input" {...inputProp} />;
    case "select":
      return <Select className="fill-in-blank-select" {...inputProp} />;
    default:
      return <></>;
  }
}
